module.exports = __webpack_public_path__ + "static/img/oil6.3957ba5d.png";